import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=d1608604"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"
import style0 from "./apps.vue?vue&type=style&index=0&id=d1608604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports